/** Job-folder / project show path from project phase. */
export function projectPhasePath(
    projectId: number,
    phase?: string | null,
): string {
    if (phase === 'quoting') return `/quotes/folders/${projectId}`;
    return `/projects/${projectId}/show`;
}

export function phaseLabel(phase: string): string {
    if (phase === 'quoting') return 'Quote';
    if (phase === 'active') return 'Active Project';
    return phase;
}

export function phaseRoute(item: { id: number; phase: string }): string {
    return projectPhasePath(item.id, item.phase);
}
